var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"options":_vm.forms,"label":"name"},model:{value:(_vm.selectedForm),callback:function ($$v) {_vm.selectedForm=$$v},expression:"selectedForm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }